import type { DeepLinkTarget } from '@wlb/shared/utils/deepLinking';

export const getDeepLinkWebDestination = (
  target: DeepLinkTarget | null,
): string => {
  if (!target) return '/';
  if (target.type === 'profile') {
    return `/profile/others/${encodeURIComponent(target.userId)}`;
  }
  if (target.type === 'group') {
    return `/groups/${encodeURIComponent(target.groupId)}`;
  }
  return `/?postId=${encodeURIComponent(target.postId)}`;
};
